import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';

import {EventUserInfo} from '../models/user-info';
import {UnregisterService} from '../services/unregister.service';
import {DataStoreService} from 'app/shared/data-store/services/data-store.service';
import {map} from 'rxjs/operators';

@Component({
  selector: 'unregister',
  templateUrl: './unregister.component.html',
  styleUrls: ['./unregister.component.css'],
})
export class UnregisterComponent implements OnInit {

  public userInfo: EventUserInfo;
  public error: string;
  private errorMap: {} = {
    'invalid email': 'Die gewählte E-Mail Adresse ist ungültig.',
    'invalid code': 'Die Löschung hat nicht funktioniert, bitte geben sie noch einmal ihr Passwort mit an.',
    'invalid password': 'Die Löschung hat nicht funktioniert, möglicherweise stimmt das Passwort nicht.',
    'invalid role': 'Admin-Accounts müssen über die Admin-Web-App gelöscht werden.',
  };

  private lang: string = '';

  constructor(private router: Router,
              private route: ActivatedRoute,
              private unregisterService: UnregisterService,
              private dataStoreService: DataStoreService) {

    this.userInfo = {
      email: '',
      password: '',
      code: null,
    };
  }

  public ngOnInit(): void {
    this.route.params.pipe(map((params) => {
      return params;
    }))
      .subscribe((routeParams) => {
        this.userInfo.email = routeParams.email;
      });

    this.route.queryParams.pipe(map((params) => {
      return params;
    }))
      .subscribe((queryParams) => {
        this.userInfo.code = queryParams.code;
        this.lang = queryParams.lang;
      });
  }

  public onSubmit(): void {
    this.unregisterService.unregister(this.userInfo)
      .subscribe(
        (result: string) => {
          this.dataStoreService.lang = this.lang;
          this.router.navigateByUrl('/thanks');
        },
        (error: Error) => {
          const message: string = error.message;

          this.userInfo.code = null;

          if (this.errorMap[message]) {
            this.error = this.errorMap[message];
            return;
          }

          this.error = message;
        },
      );
  }

  public onCancel(): void {
    window.location.href = 'https://www.leada.de/';
  }

  public langSafe(de: string, en: string, linebreak: boolean = false): string {
    if (this.lang == 'de' ) {
      return de;
    }
    if (this.lang == 'en' ) {
      return en;
    }
    return de + ' / ' + (linebreak ? '<br/>' : '') + en;
  }
}
